"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BoxFooter;

var _react = _interopRequireWildcard(require("react"));

var _contexts = require("../app/contexts");

var _helpers = require("./helpers");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function BoxFooter() {
  const {
    reset
  } = (0, _react.useContext)(_contexts.Storage);
  const {
    strings
  } = (0, _react.useContext)(_contexts.Settings);
  const footerStr = (0, _helpers.useStrOrStateFunc)(strings.footer);
  const onResetBtnClick = (0, _helpers.useHookedFunc)("onResetBtnClick", reset);
  return /*#__PURE__*/_react.default.createElement("p", {
    className: "donation-encourager__meta"
  }, /*#__PURE__*/_react.default.createElement("small", null, footerStr, " ", /*#__PURE__*/_react.default.createElement("button", {
    className: "donation-encourager__reset-btn",
    onClick: onResetBtnClick
  }, strings.resetBtn)));
}